import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isChildViewport } from '../../../util/isChildViewport';

const DatasourceQuerySwitcher = () => {
  const location = useLocation();
  const appConfig = useSelector((state) => state.config);

  useEffect(() => {
    const url = new URL(window.location.href);
    let shouldReplaceUrl = false;

    if (url.searchParams.has('Nasi')) {
      try {
        sessionStorage.setItem('Nasi', url.searchParams.get('Nasi') || '');
        url.searchParams.delete('Nasi');
        shouldReplaceUrl = true;
      } catch (error) {
        // Leave Nasi in the URL if sessionStorage is unavailable.
      }
    }

    // The child viewport uses `sid` to restore its layout. Do not consume or
    // remove that query parameter as a datasource selector in the child.
    if (isChildViewport()) {
      if (shouldReplaceUrl) {
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      }
      return;
    }

    const parameter = appConfig.PACS_SELECTOR_IN_URL_PARAM || 'datasource';
    const datasource = new URLSearchParams(location.search).get(parameter);

    const { PACS_SELECTOR_CONFIG } = appConfig;

    if (!datasource || !PACS_SELECTOR_CONFIG) {
      if (shouldReplaceUrl) {
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      }
      return;
    }

    const selectedPacsIndex = sessionStorage.getItem('selectedPacsIndex');
    const datasourceIndex = PACS_SELECTOR_CONFIG.findIndex(
      (pacs) => String(pacs.id) === datasource
    );

    if (datasourceIndex < 0) {
      if (shouldReplaceUrl) {
        window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
      }
      return;
    }

    const isSelectedPacsAlreadyActive = String(datasourceIndex) === selectedPacsIndex;

    if (!isSelectedPacsAlreadyActive) {
      sessionStorage.setItem('selectedPacsIndex', parseInt(datasourceIndex, 10));
    }

    url.searchParams.delete(parameter);
    window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);

    if (!isSelectedPacsAlreadyActive && window.location) window.location.reload();
  }, []);

  return null;
};

export default DatasourceQuerySwitcher;
